import PageLoadedQueue from "../PageLoadedQueue";

/**
 * article accessories, correspondingto, productfamily display more button
 */
export function loadMoreAccessories() {
    const loadMoreAccessories: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.load-more-accessories button');

    if (loadMoreAccessories.length > 0) {
        loadMoreAccessories.forEach((button) => {
            button.addEventListener('click', () => {
                const printElementOnPage: HTMLElement = document.querySelector('.article-print[data-print-url]');

                if (printElementOnPage) {
                    const url = printElementOnPage.dataset.printUrl;
                    printElementOnPage.dataset.printUrl = url + '&displayAll=true';
                }

                const tabPane: HTMLElement = button.closest('.accordion-collapse');

                if (tabPane) {
                    const tabPaneChildren: NodeListOf<HTMLElement> = tabPane.querySelectorAll('li,.product-list-item-container,.product-gallery-item');
                    tabPaneChildren.forEach((tabPaneChild) => {
                        tabPaneChild.classList.remove('d-none');
                    });
                }

                const productFamilyList: HTMLElement = button.closest('.product-family-list');
                if (productFamilyList) {
                    const productFamilyListChildren: NodeListOf<HTMLElement> = productFamilyList.querySelectorAll('.product-teaser-item-wrapper');
                    productFamilyListChildren.forEach((productFamilyListChild) => {
                        productFamilyListChild.classList.remove('d-none');
                    });
                }

                button.classList.add('d-none');
            }, {passive: true});
        });
    }
}

PageLoadedQueue.addFunction(loadMoreAccessories);
